import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CheckboxIcon from '@wix/da-ds/pkg/Icons/16x16/Checkbox';
import RadioIcon from '@wix/da-ds/pkg/Icons/16x16/Radio';
import EditIcon from '@wix/da-ds/pkg/Icons/16x16/Edit';
import { QuestionFieldName } from '../../types';

interface Props {}

const AnswerTypeField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: QuestionFieldName.QUESTION_TYPE, control });

  const items: DropdownOption[] = [
    {
      label: t('originalDeviationPopup.questionnaire.form.answerType.freeText'),
      value: 'free_text',
      selected: value === 'free_text',
      icon: <EditIcon size={IconSize.SMALL} disableDefaultColors />,
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.singleChoice'
      ),
      value: 'single_choice',
      selected: value === 'single_choice',
      icon: <RadioIcon size={IconSize.SMALL} disableDefaultColors />,
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.multipleChoice'
      ),
      value: 'multiple_choice',
      selected: value === 'multiple_choice',
      icon: <CheckboxIcon size={IconSize.SMALL} disableDefaultColors />,
    },
  ];

  return (
    <SelectField
      id={id}
      label={t('originalDeviationPopup.questionnaire.form.answerType.label')}
      items={items}
      value={value}
      onChange={onChange}
      withBlankOption={false}
      showPrefixIcons={true}
    />
  );
};
AnswerTypeField.displayName = 'AnswerTypeField';

export default AnswerTypeField;
